import React from 'react';
import { Box, VStack, Heading, Text, Image, Divider } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaCheck } from 'react-icons/fa';

import LogoBarber from '../../assets/Logo-Barber.png';

const MotionBox = motion(Box);

const MobileWelcomePage = () => {
  return (
  <MotionBox 
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.5 }}
    minH="100vh" 
    bg="black" 
    color="white" 
    display="flex" 
    flexDirection="column"
    alignItems="center" 
    justifyContent="center"
    bgGradient="linear(to-b, gray.900, black)"
    px={4}
    py={8}
  >
    <MotionBox
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.5 }}
      mb={8}
    >
      <Image 
        src={LogoBarber} 
        alt="Logo Barbearia Freire" 
        maxW="150px" 
        mx="auto"
        filter="drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5))"
      />
    </MotionBox>

    <MotionBox
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.4, duration: 0.5 }}
      w="100%" 
      maxW="400px" 
      bg="gray.800" 
      p={8} 
      borderRadius="2xl" 
      boxShadow="0 8px 32px rgba(0, 0, 0, 0.5)"
      border="1px solid"
      borderColor="whiteAlpha.200"
      backdropFilter="blur(10px)"
    >
      <VStack spacing={6} align="stretch">
        <Box textAlign="center">
          <MotionBox
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.5 }}
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            bg="green.500"
            color="white"
            borderRadius="full"
            w="80px"
            h="80px"
            mb={4}
            mx="auto"
            boxShadow="0 0 20px rgba(56, 178, 172, 0.5)"
          >
            <FaCheck size={40} />
          </MotionBox>
          <Heading size="lg" color="white" mb={2}>Check-in Concluído!</Heading>
          <Text color="whiteAlpha.800" fontSize="lg">Seu check-in foi realizado com sucesso.</Text>
        </Box>

        <Divider borderColor="whiteAlpha.200" />

        <Box 
          bg="gray.700" 
          p={4} 
          borderRadius="xl" 
          boxShadow="md"
          textAlign="center"
          borderLeft="4px solid"
          borderColor="yellow.400"
        >
          <Text fontWeight="bold" fontSize="lg" color="yellow.400">O seu atendimento irá começar em breve...</Text>
        </Box>
      </VStack>
    </MotionBox>

    <Text mt={8} fontSize="sm" color="whiteAlpha.600" textAlign="center">
      © 2025 Barbearia Freire • Todos os direitos reservados
    </Text>
  </MotionBox>
  );
};

export default MobileWelcomePage;
